import { Component, ElementRef, EventEmitter, OnInit, OnDestroy, Output, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { first } from 'rxjs/internal/operators/first';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { ProfileResponse, ProfileRequest, ProfileInfo, ProfileUpdateResponse, AttractLoop, Settings } from '../interface/profile.i';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { ProfileStoreService } from '../store/profile.store';
import { AppGlobal } from '../../../../app/core/state/app-global';
import { User } from '../../account/login/_models/user.model';
import { LANGUAGE_MAPPINGS } from '../../../common/constants/language-mappings.const';
import * as FactTagsData from '../../../../assets/config/factTags.json';
import * as ChromeFactTagsData from '../../../../assets/config/chromeFactTags.json';
import { Utils } from '../../../common/utils/utils';
import { DevicesConstants } from '../../../core/routing/services/devices/constants/devices.constants';
import { CommonService } from '../../../common/services/common.service';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { environment } from '../../../../environments/environment';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SkuIdInfoService } from '../../../../app/core/routing/services/sku-ids/sku-id-info.service';

@Component({
  selector: 'iposcen-profile-info',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss']
})
export class ProfileInfoComponent implements OnInit, OnDestroy {
  @Input() profileId: string;
  @Output() readonly gotoBackCreateProfile = new EventEmitter<object>();
  @Output() readonly iposLiteEnabled = new EventEmitter<object>();
  @ViewChild('contentTypeStandard') contentTypeStandard: ElementRef;
  @ViewChild('contentTypeGaming') contentTypeGaming: ElementRef;
  @ViewChild('contentTypeCreator') contentTypeCreator: ElementRef;
  @ViewChild('contentTypeError') contentTypeError: ElementRef;
  @ViewChild('profileLanguageModal') profileLanguageModal: ElementRef;
  @ViewChild('attractLoopModal') attractLoopModal: ElementRef;

  operatingSystem: string;
  isAttractorLoopRadionBtn: boolean;
  selectedLangauge = [] as any;
  selectedLangaugeName = [] as any;
  languageJSON = [];
  profileInfoFrm: FormGroup;
  isSubmitted: boolean;
  isGamingMsg: boolean;
  isCreatorPart: boolean;
  QrCodeStatus: string;
  gameDemoStatus: string;
  creatorDemoStatus: string;
  neroDemoStatus: string;
  rxtStatus: string;
  idleTimeValue: string;
  contentType: string[] = [];
  idleDisplayValue: string;
  useMSProfileStatus: boolean;
  isincreasePromotionRotation: boolean;
  is4kVideoIncluded: boolean;
  playVid = false;
  isStandardPart: boolean;
  noContent: boolean;
  isCompRxtEnabled: boolean;
  isLanguageEmpty: boolean;
  isAttrLoopEmpty: boolean;
  isAttrctLoopSelected: boolean;
  // TODO: downloadLinkUWPApp needs to be changed after get new URL from pckaging team
  downloadLinkUWPApp: string = 'https://intelipos.lbi.io/';
  profileData: ProfileRequest;
  profileInfoData: ProfileInfo;
  attractLoop: AttractLoop;
  selectedAttractLoopId: string;
  timerData = Utils.getIdleTimeData();
  settingsData: any;
  factTagsData: any;
  chromeFactTagsData: any;
  userRole: string;
  retailerId: string;
  retailerName: string;
  retailerConfig: any;
  searchPlaceholderText: string = $localize`:@@profile-info.profile-name.search-input.placeholder:Enter profile name`;
  oneMinute = GlobalConstants.ONE_MINUTE;
  oneAndHalfMinute = GlobalConstants.ONE_AND_HALF_MINUTE;
  twoMinutes = GlobalConstants.TWO_MINUTES;
  fiveMinutes = GlobalConstants.FIVE_MINUTES;
  tenMinutes = GlobalConstants.TEN_MINUTES;
  twentyMinutes = GlobalConstants.TWENTY_MINUTES;
  chrome_os = GlobalConstants.CHROME_OS;
  globalconst = GlobalConstants;
  available_game: string = '';
  available_demo: string[] = [];
  userId: string;
  private ngUnsubscribe = new Subject<boolean>();
  specialChar: boolean;
  prevSelectedOS: string;
  imgUrl: string;
  gameDemosHref: string;
  enableGameDemosPopup: boolean = false;
  modalReference: any;
  isChromeOs: boolean;
  profileSkuList: any[];
  selectedProfileSkus: any = [];
  fetchedProfileSkus: any = [];
  disabledSelectedSkus = false;
  burnIn = GlobalConstants.BURN_IN_VIDEO;
  includeLogoContent = GlobalConstants.INCLUDE_LOGO_CONTENT;
  includeLogoContentSubstr = GlobalConstants.INCLUDE_LOGO_CONTENT_SUBSTRING;
  includeSegmentContent = GlobalConstants.INCLUDE_SEGMENT_CONTENT;
  includeSegmentContentSubstr = GlobalConstants.INCLUDE_SEGMENT_CONTENT_SUBSTRING;
  fTagRotation = GlobalConstants.FTG_ROTATION;
  fTagRotationSubstr = GlobalConstants.FTG_ROTATION_SUBSTR;
  increaseRotation = GlobalConstants.INCREASE_ROTATION;
  increaseRotationSubstr = GlobalConstants.INCREASE_ROTATION_SUBSTR;
  includeStandard4K = GlobalConstants.INCLUDE4K;
  includeStandard4KSubstr = GlobalConstants.INCLUDE4K_SUBSTR;
  isLogoContentEnabled: boolean;
  isSegmentContentEnabled: boolean;
  includeUnisonDemoStatus: boolean;
  enableIposlitePRC: boolean = false;
  retailerConfigIposLite: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private createProfileService: CreateProfileService,
    private appGlobal: AppGlobal,
    private profileStoreService: ProfileStoreService,
    private cmnService: CommonService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private modalService: NgbModal,
    private skuIdService: SkuIdInfoService) { }

  ngOnInit(): void {
    this.gameDemosHref = RouterConstants.GAME_DEMOS_LINK;
    this.prevSelectedOS = '';
    this.retailerId = sessionStorage.getItem('retailerId');
    this.retailerName = sessionStorage.getItem('retailerName');
    this.userId = sessionStorage.getItem(GlobalConstants.USER_ID);
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        this.userRole = userAccount.role;
        this.isCompRxtEnabled = userAccount.isCompRxtEnabled;
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          this.retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.cmnService.getRetailerConfig(this.userId, this.retailerId);
        } else if (this.userRole === GlobalConstants.SRT_ADMIN) {
          await this.getAllProfileSkus();
        }
      });
    this.operatingSystem = GlobalConstants.WINDOWS;
    this.idleTimeValue = GlobalConstants.IDLE_TIME_VALUE;
    this.idleDisplayValue = GlobalConstants.FACT_TAG_ROTATION_VALUE;
    this.useMSProfileStatus = true;
    this.includeUnisonDemoStatus = false;
    this.isAttractorLoopRadionBtn = false;
    this.isGamingMsg = false;
    this.isCreatorPart = false;
    this.isincreasePromotionRotation = false;
    this.is4kVideoIncluded = false;
    this.isLogoContentEnabled = (this.settingsData?.idleExperience?.isLogoContentEnabled ? this.settingsData?.idleExperience?.isLogoContentEnabled : false);
    this.isSegmentContentEnabled = (this.settingsData?.idleExperience?.isSegmentContentEnabled ? this.settingsData?.idleExperience?.isSegmentContentEnabled : false);
    this.isAttrLoopEmpty = false;
    this.isAttrctLoopSelected = false;
    this.specialChar = false;
    // reading default fact tags when no fact tags selected or saved from the fact tags tab
    this.factTagsData = JSON.stringify((FactTagsData as any).default);
    this.chromeFactTagsData = JSON.stringify((ChromeFactTagsData as any).default);
    this.isStandardPart = true;
    this.createProfileInfoForm();
    this.isSubmitted = false;
    this.noContent = false;
    this.isLanguageEmpty = false;
    this.selectedLangauge.push(localStorage.getItem('preferredLanguage'));
    LANGUAGE_MAPPINGS.forEach(element => {
      if (element.langCode === this.globalconst.CHINESE_TW) {
        element.langCode = this.globalconst.CHINESE_HANT;
      } else if (element.langCode === this.globalconst.CHINESE_CN) {
        element.langCode = this.globalconst.CHINESE_HANS;
      }
      const langCode = this.selectedLangauge.find(item => item.toLowerCase() === element.langCode.toLowerCase());
      if (langCode) {
        this.selectedLangaugeName.push(element.langInEng);
      }
    });
    this.QrCodeStatus = GlobalConstants.ENABLED;
    this.gameDemoStatus = GlobalConstants.INCLUDE_GAME;
    this.creatorDemoStatus = GlobalConstants.INCLUDE;
    this.neroDemoStatus = GlobalConstants.INCLUDE;
    this.rxtStatus = GlobalConstants.ENABLED;
    this.contentType.push(GlobalConstants.STANDARD);
    if (this.profileId) {
      //IIT2-8949 Setting all content types to false, data will be updated from profile data.
      this.isGamingMsg = false;
      this.isCreatorPart = false;
      this.isStandardPart = false;
      this.getProfileDataByProfileId();
      this.createProfileService.setProfileId(this.profileId);
    } else {
      this.available_game = this.globalconst.MONSTER_HUNTER_SUNBREAK_VALUE;
      this.available_demo = [this.globalconst.WONDERSHARE_FILMORA];
      this.setDefaultValuesforProfSettings();
    }
    this.imgUrl = environment.apiBaseUrlAsset + GlobalConstants.STANDARD_4K_VIDEO;
    this.retailerConfigIposLite = this.retailerConfig.isIposChinaEnabled ? this.retailerConfig.isIposChinaEnabled : false;
    if (this.retailerConfigIposLite) {
      this.enableIposlitePRC = true;
      this.iposLiteEnabled.emit([this.enableIposlitePRC]);
    }
  }

  addDemoItems(item: string) {
    this.available_demo.push(item);
  }

  setDefaultValuesforProfSettings() {
    // For create new profile adding default values for below both keys as part of settings.
    // For IIT2-9910 - Added default value for compareTabText(Customize compare menu item).
    // For UAT-464, removed default passwords for primary and uninstall.
    this.settingsData = {
      compareTabText: GlobalConstants.COMPARE_TAB_DEFAULT_TEXT,
      customizableButton: {
        animationButton: false,
        buttonFunctionality: {
          type: GlobalConstants.DeviceSpec,
          url: "",
          customButtonCopyText: GlobalConstants.EXPLORE_THIS_PC_CAPS
        }
      }
    };
  }

  getSelectedOperatingSystem(selectedOS) {
    this.noContent = false;
    this.operatingSystem = selectedOS;
    if (selectedOS === GlobalConstants.WINDOWS) {
      let otherSettingsInfo;
      if (this.profileId != undefined) {
        const settingsInfo = this.profileData?.settings;
        otherSettingsInfo = JSON.parse(settingsInfo);
      }
      this.useMSProfileStatus = (this.profileId != undefined) ? otherSettingsInfo?.otherSettings?.useMSProfiles : true;
      this.includeUnisonDemoStatus = (this.profileId != undefined) ? otherSettingsInfo?.otherSettings?.includeUnisonDemo : false;
      const hasStandard = otherSettingsInfo?.otherSettings?.contentTypes?.packagedTypes.includes(GlobalConstants.STANDARD) ? true : false;
      const hasGaming = otherSettingsInfo?.otherSettings?.contentTypes?.packagedTypes.includes(GlobalConstants.GAMING) ? true : false;
      const hasCreator = otherSettingsInfo?.otherSettings?.contentTypes?.packagedTypes.includes(GlobalConstants.CREATOR) ? true : false;
      const isNoneSelected = (!hasStandard && !hasGaming && !hasCreator) ? true : hasStandard;
      this.isStandardPart = (this.profileId != undefined) ? isNoneSelected : true;
      this.isGamingMsg = (this.profileId != undefined) ? hasGaming : false;
      this.isCreatorPart = (this.profileId != undefined) ? hasCreator : false;
      this.contentTypeGeneration(this.isStandardPart, GlobalConstants.STANDARD);
      this.contentTypeGeneration(this.isGamingMsg, GlobalConstants.GAMING);
      this.contentTypeGeneration(this.isCreatorPart, GlobalConstants.CREATOR);
    } else {
      this.includeUnisonDemoStatus = false;
      this.isCreatorPart = false;
      this.isGamingMsg = false;
      this.isStandardPart = false;
      this.contentType = []; //IIT3-918: Resetting the contentType array to empty, as other OS except windows does not use contenttype selection. 
      this.profileInfoFrm.controls.excludeGameDemo.setValue(true);// Setting default values
      this.profileInfoFrm.controls.excludeAIDemo.setValue(true);
      this.profileInfoFrm.controls.excludeCreatorApp.setValue(true);
      this.profileInfoFrm.controls.excludeNeroApp.setValue(true);
      this.available_game = this.globalconst.MONSTER_HUNTER_SUNBREAK_VALUE;
    }
    this.isChromeOs = selectedOS === GlobalConstants.CHROME_TEXT; //IIT3-1273
    this.cmnService.emitChromeBookSelection(selectedOS === GlobalConstants.CHROME_TEXT ? true : false);
  }

  getSelectedIdleTime(selectedIdleTime) {
    this.idleTimeValue = selectedIdleTime;
  }

  getIdleDisplay(selectedIdleDisplayValue) {
    this.isincreasePromotionRotation = false;
    if (selectedIdleDisplayValue === GlobalConstants.FACT_TAG_ROTATION_VALUE) {
      this.isAttractorLoopRadionBtn = false;
      this.isAttrctLoopSelected = false;
      this.isAttrLoopEmpty = false;
      this.idleDisplayValue = GlobalConstants.FACT_TAG_ROTATION_VALUE;
      this.is4kVideoIncluded = false;
      this.setDefaultAttractLoop();
    } else if (selectedIdleDisplayValue === GlobalConstants.ATTRACT_LOOP_VALUE) {
      this.isLogoContentEnabled = false;
      this.isSegmentContentEnabled = false;
      this.isAttractorLoopRadionBtn = true;
      this.idleDisplayValue = GlobalConstants.ATTRACT_LOOP_VALUE;
      if (this.selectedAttractLoopId) {
        this.attractLoop = {
          attractLoopId: this.selectedAttractLoopId,
          showOnDevice: true
        };
        this.isAttrctLoopSelected = true;
      }
    }
  }

  getProfileDataByProfileId() {
    // Temp fix for IIT2-9839: Commmenting the below If condition.

    //const existingProfileData = this.profileStoreService.currentWorkingProfile;
    // if (existingProfileData && (existingProfileData?.profileId === this.profileId)) {
    //   this.profileData = existingProfileData as ProfileRequest;
    //   this.settingsData = this.profileData?.settings ? JSON.parse(this.profileData?.settings) : {};
    //   this.profileInfoData = this.settingsData.otherSettings as ProfileInfo;
    //   this.editProfileInfoForm();
    // } else {
    this.createProfileService.getAllSavedContentGroups(this.profileId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(profileResponse => {
        this.profileData = profileResponse.profile as ProfileRequest;
        const updateProfileStore: ProfileUpdateResponse = profileResponse.profile as ProfileUpdateResponse;
        this.profileStoreService.currentWorkingProfile = updateProfileStore;
        this.createProfileService.setProfileId(this.profileId);
        this.settingsData = this.profileData?.settings ? JSON.parse(this.profileData?.settings) : {};
        this.profileInfoData = this.settingsData.otherSettings as ProfileInfo;
        this.editProfileInfoForm();
      });
    //}
  }

  editProfileInfoForm() {
    this.available_demo = [];
    this.profileInfoFrm = this.formBuilder.group({
      profileName: new FormControl(this.profileData) ? this.profileData?.profileName : '',
      excludeGameDemo: new FormControl(this.profileInfoData) ?
        (!this.profileInfoData?.isExcludeGameDemo ? true : false) : true,
      excludeAIDemo: new FormControl(this.profileInfoData) ?
        (!this.profileInfoData?.isExcludeAiDemo ? true : false) : true,
      excludeCreatorApp: new FormControl(this.profileInfoData) ?
        (!this.profileInfoData?.isExcludeCreatorApp ? true : false) : true,
      displayQR: new FormControl(this.profileInfoData) ? this.profileInfoData?.isMobileContactlessExp : true,
      includeRXT: new FormControl(this.profileInfoData) ? this.profileInfoData?.isRXTDemo : false,
      excludeNeroApp: new FormControl(this.profileInfoData) ?
        (!this.profileInfoData?.isExcludeNeroScoreApp ? true : false) : true
    });
    if (this.profileInfoData?.available_game) {
      this.available_game = this.profileInfoData?.available_game === this.globalconst.THREE_KINGDOMS_VALUE ? this.globalconst.MONSTER_HUNTER_SUNBREAK_VALUE : this.profileInfoData?.available_game
    } else {
      this.available_game = this.globalconst.MONSTER_HUNTER_SUNBREAK_VALUE;
    } 
    if (this.profileInfoData?.available_demo) {
      this.available_demo = this.profileInfoData?.available_demo;
    } else if (this.operatingSystem === GlobalConstants.WINDOWS || this.operatingSystem === GlobalConstants.WINDOWSUWP
      || this.operatingSystem === GlobalConstants.WINDOWS_10S) {
      this.addDemoItems(this.globalconst.WONDERSHARE_FILMORA);
    }
    if (this.profileInfoData.operatingSystem === GlobalConstants.CHROME_TYPE)
      this.cmnService.emitChromeBookSelection(true);
    this.selectedLangauge = this.profileInfoData.languages.selectedLanguages;
    this.getSelectedlanguageName();
    this.prevSelectedOS = this.profileInfoData.operatingSystem;
    this.operatingSystem = Utils.getOperatingSystemTypeFromServer(this.profileInfoData.operatingSystem);
    // this.cmnService.emitChromeBookSelection(this.operatingSystem === GlobalConstants.CHROME_TEXT ? true : false); // II-3289 IIT2-1594
    this.isChromeOs = this.operatingSystem === GlobalConstants.CHROME_TEXT; //IIT3-1273
    this.idleTimeValue = this.settingsData?.idleExperience?.TimeUntilIdle;
    this.isLogoContentEnabled = this.settingsData?.idleExperience?.isLogoContentEnabled;
    this.isSegmentContentEnabled = this.settingsData?.idleExperience?.isSegmentContentEnabled
    this.useMSProfileStatus = this.profileInfoData.useMSProfiles;
    this.includeUnisonDemoStatus = this.profileInfoData.includeUnisonDemo;
    this.contentType = this.profileInfoData.contentTypes?.packagedTypes;
    this.contentType.forEach(ele => {
      if (ele === GlobalConstants.GAMING) {
        this.isGamingMsg = true;
      } else if (ele === GlobalConstants.CREATOR) {
        this.isCreatorPart = true;
      } else if (ele === GlobalConstants.STANDARD) {
        this.isStandardPart = true;
      }
    });
    this.idleDisplayValue = this.settingsData?.idleExperience?.IdleDisplay;
    this.isAttractorLoopRadionBtn = this.settingsData?.idleExperience?.IdleDisplay === GlobalConstants.ATTRACT_LOOP_VALUE;
    this.isincreasePromotionRotation = (
      this.settingsData?.idleExperience?.IdleDisplay === GlobalConstants.ATTRACT_LOOP_VALUE
    ) ?
      false :
      this.profileInfoData.increasePromotionRotation;
    this.selectedAttractLoopId = this.profileData.attractLoop?.attractLoopId;
    if (this.isAttractorLoopRadionBtn && this.selectedAttractLoopId) {
      this.attractLoop = {
        attractLoopId: this.selectedAttractLoopId,
        showOnDevice: true
      };
      this.isAttrctLoopSelected = true;
    } else {
      this.setDefaultAttractLoop();
      this.isAttrctLoopSelected = false;
    }
    this.is4kVideoIncluded = (
      this.settingsData?.idleExperience?.IdleDisplay === GlobalConstants.ATTRACT_LOOP_VALUE
    ) ? this.settingsData?.idleExperience?.isStandard4kVideoIncluded : false;
    this.enableIposlitePRC = this.settingsData?.otherSettings.enableProfileIposlite;
  }

  getSelectedlanguageName() {
    this.selectedLangaugeName = [];
    for (let i = 0; i < this.selectedLangauge.length; i++) {
      if (this.selectedLangauge[i] === this.globalconst.CHINESE_TW) {
        this.selectedLangauge[i] = this.globalconst.CHINESE_HANT;
      } else if (this.selectedLangauge[i] === this.globalconst.CHINESE_CN) {
        this.selectedLangauge[i] = this.globalconst.CHINESE_HANS;
      }
    }
    LANGUAGE_MAPPINGS.forEach(element => {
      if (element.langCode === this.globalconst.CHINESE_TW) {
        element.langCode = this.globalconst.CHINESE_HANT;
      } else if (element.langCode === this.globalconst.CHINESE_CN) {
        element.langCode = this.globalconst.CHINESE_HANS;
      }
      const langCode = this.selectedLangauge.find(item => item.toLowerCase() === element.langCode.toLowerCase());
      if (langCode) {
        this.selectedLangaugeName.push(element.langInEng);
        this.isLanguageEmpty = (this.selectedLangaugeName.length <= 0);
      }
    });
  }

  createProfileInfoForm() {
    this.profileInfoFrm = this.formBuilder.group({
      profileName: new FormControl(''),
      OperatingSystemVal: new FormControl(''),
      selectedLangauge: new FormControl(''),
      idleTime: new FormControl(''),
      excludeGameDemo: new FormControl(true),
      excludeAIDemo: new FormControl(true),
      excludeCreatorApp: new FormControl(true),
      displayQR: new FormControl(true),
      includeRXT: new FormControl(true),
      excludeNeroApp: new FormControl(true)
    });
  }

  contentTypeGeneration(status, data) {
    if (status) {
      const itemExists = this.contentType.includes(data);
      if (!itemExists) this.contentType.push(data);
    } else {
      this.contentType = this.contentType.filter(item => item !== data);
    }
  }

  isGaming() {
    if (this.contentTypeGaming.nativeElement.checked ||
      this.contentTypeStandard.nativeElement.checked ||
      this.contentTypeCreator.nativeElement.checked) {
      this.noContent = false;
    }
    else {
      this.noContent = true;
    }
    this.available_game = this.contentTypeGaming.nativeElement.checked ? this.globalconst.MONSTER_HUNTER_SUNBREAK_VALUE : '';
    this.profileInfoFrm.controls.excludeGameDemo.setValue(true);// Setting default value
    this.isGamingMsg = !this.isGamingMsg
    this.contentTypeGeneration(this.isGamingMsg, GlobalConstants.GAMING);
  }

  isCreator() {
    if (this.contentTypeGaming.nativeElement.checked ||
      this.contentTypeStandard.nativeElement.checked || this.contentTypeCreator.nativeElement.checked) {
      this.noContent = false;
    }
    else {
      this.noContent = true;
    }
    this.profileInfoFrm.controls.excludeCreatorApp.setValue(true);// Setting default value
    this.profileInfoFrm.controls.excludeNeroApp.setValue(true);// Setting default value
    this.isCreatorPart = !this.isCreatorPart;
    this.contentTypeGeneration(this.isCreatorPart, GlobalConstants.CREATOR);
  }

  //GLS fix: Translation applied for Operating system types
  spell(option: string) {
    if (option === ('Windows' || 'IPOSLITE')) {
      return DevicesConstants.WINDOWS_OS;
    } else if (option === 'Linux/Devices with no operating systems') {
      return DevicesConstants.LINUX_OS;
    } else if (option === 'UWP for Windows in S Mode') {
      return DevicesConstants.WINDOWSUWP_OS;
    }
    else if (option === 'Chromebook') {
      return GlobalConstants.CHROME_OS;
    }
  }

  onAdd() {
    this.available_demo = [];
    if (this.is4kVideoIncluded) {
      this.googleAnalyticsService.is4kVideoEnabled()
    }
    this.isSubmitted = true;
    this.checkChineseLangFormat();
    if (this.profileInfoFrm.controls.profileName.value === '') {
      return;
    }
    const os = Utils.getOperatingSystemTypes(this.operatingSystem); // IIT2-5312
    if (this.operatingSystem === GlobalConstants.WINDOWS || this.operatingSystem === GlobalConstants.WINDOWSUWP
      || this.operatingSystem === GlobalConstants.WINDOWS_10S) {
      this.addDemoItems(this.globalconst.WONDERSHARE_FILMORA);
    }
    const profileInfo: ProfileInfo = {
      contentTypes: {
        packagedTypes: this.contentType
      },
      useMSProfiles: this.useMSProfileStatus,
      includeUnisonDemo: this.retailerConfig?.enableUnisonDemo ? this.includeUnisonDemoStatus : false,
      increasePromotionRotation: (
        this.idleDisplayValue === GlobalConstants.ATTRACT_LOOP_VALUE
      ) ?
        false : this.isincreasePromotionRotation,
      isExcludeGameDemo: this.isGamingMsg ? (this.profileInfoFrm.controls.excludeGameDemo.value ? false : true) : true,
      isExcludeAiDemo: this.profileInfoFrm.controls.excludeAIDemo.value ? false : true,
      isExcludeCreatorApp: this.isCreatorPart ? (this.profileInfoFrm.controls.excludeCreatorApp.value ? false : true) : true,
      isExcludeNeroScoreApp: this.isCreatorPart ? (this.profileInfoFrm.controls.excludeNeroApp.value ? false : true) : true,
      isMobileContactlessExp: this.profileInfoFrm.controls.displayQR.value,
      isRXTDemo: this.profileInfoFrm.controls.includeRXT.value,
      includeGaming: false,
      available_game: this.available_game,
      available_demo: this.available_demo,
      gameEmbedded: false,
      embeddedApps: [],
      deleteUGC: false,
      languages: {// All language code must be in lowercase to avoid packaging issue.
        selectedLanguages: this.selectedLangauge.map(langCode => langCode.toLowerCase()),
        userLocale: '',
        locale: this.selectedLangauge?.length ? this.selectedLangauge[0].toLowerCase() : ''
      },
      operatingSystem: os, // IIT2-5312
      allowNonIntel: this.settingsData.otherSettings?.allowNonIntel ?
        this.settingsData.otherSettings?.allowNonIntel :
        true,//default values for settings tab
      desktopPasswordProtection: this.settingsData.otherSettings?.desktopPasswordProtection ?
        this.settingsData.otherSettings?.desktopPasswordProtection :
        false,
      priceEntryInstallation: this.settingsData.otherSettings?.priceEntryInstallation !== undefined ?
        this.settingsData.otherSettings?.priceEntryInstallation : true,
      enableMobileSocket: GlobalConstants.SOCKET_DEFAULT_VALUE,
      pollFrequency: (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
        (this.retailerConfig?.pollFrequency ? this.retailerConfig?.pollFrequency : GlobalConstants.POLL_FREQ_DEFULT_VALUE) :
        GlobalConstants.POLL_FREQ_DEFULT_VALUE,
      enableProfileIposlite: this.enableIposlitePRC,
      aiPlaygroundPSFile : "C:\\AI-Playground\\AIPlayGroup.ps1"
    };
    //Gamingdemo new VD changes 8314
    if (!this.profileInfoFrm.controls.excludeGameDemo.value) {
      profileInfo.available_game = '';
    } 
    // else if (profileInfo.contentTypes.packagedTypes.includes(GlobalConstants.GAMING) && this.profileInfoFrm.controls.excludeGameDemo.value) {
    //   this.googleAnalyticsService.gameIncludedToThePackage(profileInfo?.available_game,this.profileId,this.profileData?.profileName);
    // }
    if (this.isAttrctLoopSelected) {
      this.googleAnalyticsService.attractLoopVideoSelected();
    }

    if (this.isincreasePromotionRotation) {
      this.googleAnalyticsService.profileIncreasePromoRotation();
    }
    this.googleAnalyticsService.operatingSystem(os); // IIT2-5312

    if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
      profileInfo.isCompRxtEnabled = this.isCompRxtEnabled;
    }
    profileInfo.blockWindowsUpdate = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      (this.retailerConfig?.blockWindowsUpdate !== undefined ? this.retailerConfig?.blockWindowsUpdate : false) :
      false;
    if (!this.profileInfoFrm.controls.excludeAIDemo.value) {
      profileInfo.available_demo = [];
    }
    //adding these keys so that IPOS tile can use it.
    profileInfo.enable3DMarkFeature = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      (this.retailerConfig?.enable3DMarkFeature !== undefined ? this.retailerConfig?.enable3DMarkFeature : false) :
      false;

    profileInfo.enableElkjopULBenchmark = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      (this.retailerConfig?.enableElkjopULBenchmark !== undefined ? this.retailerConfig?.enableElkjopULBenchmark : false) :
      false;

    profileInfo.isBrandColorEnabled = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      (this.retailerConfig?.bandColor !== undefined ? this.retailerConfig?.bandColor : false) :
      false;
    profileInfo.processorFactTagSuppress = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      (this.retailerConfig?.processorFactTagSuppress !== undefined ? this.retailerConfig?.processorFactTagSuppress : false) :
      false;
    profileInfo.isRepairabilityIndexEnabled = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      (this.retailerConfig?.isRepairabilityIndexEnabled !== undefined ? this.retailerConfig?.isRepairabilityIndexEnabled : false) :
      false;
    profileInfo.isChatbotEnabled = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      (this.retailerConfig?.isChatbotEnabled !== undefined ? this.retailerConfig?.isChatbotEnabled : false) :
      false;
    profileInfo.isEciRetailer = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      (this.retailerConfig?.isEciRetailer !== undefined ? this.retailerConfig?.isEciRetailer : false) :
      false;
    profileInfo.brandColor = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      (this.retailerConfig?.bgcolor ? this.retailerConfig?.bgcolor : "") : "";
    if ((this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) &&
      this.retailerConfig?.displayDeviceRetailerId?.length) {
      profileInfo.displayDeviceRetailerId = this.retailerConfig?.displayDeviceRetailerId;
    }
    else if (this.settingsData?.otherSettings?.displayDeviceRetailerId) {
      //deleting displayDeviceRetailsId. if added previously and disabled now
      delete this.settingsData?.otherSettings?.displayDeviceRetailerId;
    }
    if (this.enableIposlitePRC) {
      profileInfo.languages = {
        locale: "zh-cn",
        selectedLanguages: ['zh-cn'],
        userLocale: ""
      };
      profileInfo.operatingSystem = 'IPOSLITE';
      profileInfo.contentTypes.packagedTypes = ['IposLite'];
    }
    this.settingsData.otherSettings = this.settingsData.otherSettings ?
      Object.assign(this.settingsData.otherSettings, profileInfo) : profileInfo;

    this.settingsData.idleExperience = {
      TimeUntilIdle: this.idleTimeValue,
      IdleDisplay: this.idleDisplayValue,
      isLogoContentEnabled: this.isLogoContentEnabled,
      isSegmentContentEnabled: this.isSegmentContentEnabled,
      isStandard4kVideoIncluded: (
        this.idleDisplayValue === GlobalConstants.FACT_TAG_ROTATION_VALUE
      ) ?
        false : this.is4kVideoIncluded
    }

    const profileInfoContent: ProfileRequest = {
      profileInfo: '',
      profileName: this.profileInfoFrm.controls.profileName.value.trim(),
      operatingSystem: '',
      languages: '',
      isIposPackaged: true,
      attractLoop: this.attractLoop,
      settings: JSON.stringify(this.settingsData as Settings)
    };
    //When user switches from AL to IE and vice versa -> UI was throwing error. IIT2-11095
    if (this.settingsData?.idleExperience?.IdleDisplay === GlobalConstants.FACT_TAG_ROTATION_VALUE) {
      delete profileInfoContent?.attractLoop;
    }

    if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER
      || this.userRole === GlobalConstants.REGIONALHQ || this.userRole === GlobalConstants.SRT_ADMIN) {
      profileInfoContent.retailerID = this.retailerId;
      profileInfoContent.retailerName = this.retailerName;
    }

    if (!this.contentType.length) {
      this.noContent = true;
    }
    if (this.prevSelectedOS !== '' && (this.prevSelectedOS !== Utils.getOperatingSystemTypes(this.operatingSystem))) {
      if (this.prevSelectedOS == GlobalConstants.CHROME_TYPE || Utils.getOperatingSystemTypes(this.operatingSystem) === GlobalConstants.CHROME_TYPE) {
        if (this.prevSelectedOS == GlobalConstants.CHROME_TYPE && Utils.getOperatingSystemTypes(this.operatingSystem) !== GlobalConstants.CHROME_TYPE) {
          //normal facttags
          profileInfoContent.factTags = this.factTagsData;
        }
        else {
          //Chrome facttags data
          profileInfoContent.factTags = this.chromeFactTagsData;
        }
      }
    }
    this.googleAnalyticsService.idleExperienceOption(this.idleDisplayValue);
    if (this.isLogoContentEnabled) {
      this.googleAnalyticsService.profileInfoLogoContentGroup();
    }
    if (this.isSegmentContentEnabled) {
      this.googleAnalyticsService.profileInfoSegmentContentGroup();
    }
    if (this.profileId) {
      this.createProfileService.updateProfile(this.profileId, profileInfoContent)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(updateProfileResponse => {
          this.googleAnalyticsService.updateProfileSuccess(this.profileId);
          const updateProfileInfo: ProfileResponse = updateProfileResponse as ProfileResponse;
          const updateProfileStore: ProfileUpdateResponse = updateProfileResponse.profile as ProfileUpdateResponse;
          updateProfileStore.profileId = this.profileId;
          this.profileStoreService.updateProfileData(updateProfileStore);
          this.createProfileService.setProfileId(this.profileId);
          this.gotoBackCreateProfile.emit(updateProfileInfo);
        },
          () => {
          }
        );

    } else {
      this.createProfileService.createProfileInfo(profileInfoContent)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(createProfileResponse => {
          this.googleAnalyticsService.createNewProfileSuccess()
          // patch call for the profiles response- default fact tags, if it is saved without entering fact tags tab.
          //Passing Chromebookfacttags set if user selected while creating profile
          this.createProfileService.updateProfile(createProfileResponse.profile.profileId, {
            factTags: (Utils.getOperatingSystemTypes(this.operatingSystem) === GlobalConstants.CHROME_TYPE) ? this.chromeFactTagsData : this.factTagsData
          })
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
              // set the tab to segment on success
              const profileUpdateResponse = data.profile as ProfileUpdateResponse;
              this.profileStoreService.updateProfileData(profileUpdateResponse);
              const createProfileInfo: ProfileResponse = createProfileResponse as ProfileResponse;
              this.createProfileService.getAllSavedContentGroups(createProfileResponse.profile.profileId)
                .pipe(takeUntil(this.ngUnsubscribe))
                .pipe(first())
                .subscribe(profileResponse => {
                  const updateProfileStore: ProfileUpdateResponse = profileResponse.profile as ProfileUpdateResponse;
                  this.profileStoreService.currentWorkingProfile = updateProfileStore;
                  this.createProfileService.setProfileId(createProfileResponse.profile.profileId);
                  this.gotoBackCreateProfile.emit(createProfileInfo);
                });
            });
        },
          () => {
          }
        );
    }
    window.scroll(0, 0);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  openModal(modal: any) { modal.open(); }

  closeModal(modal: any) { modal.close(); }

  openMultiSelectLanguageModal() {
    this.openModal(this.profileLanguageModal);
    this.cmnService.emitChromeBookSelection(this.operatingSystem === GlobalConstants.CHROME_TEXT ? true : false);
  }

  checkChineseLangFormat() {
    if (this.selectedLangauge.length > 0) {
      this.selectedLangauge.forEach((element, index) => {
        if (element === 'zh-Hans') this.selectedLangauge[index] = 'zh-cn';
        else if (element === 'zh-Hant') this.selectedLangauge[index] = 'zh-tw';
      });
    }
  }

  updateLanguageDetails(data) {
    this.selectedLangauge = data.userSelectedLanguage;
    this.selectedLangaugeName = data.userSelectedLanguageName;
    this.isLanguageEmpty = (this.selectedLangaugeName.length <= 0);
    this.closeModal(this.profileLanguageModal);
  }

  removeExtraLang(data) {
    this.selectedLangauge = data.userSelectedLanguage;
    this.selectedLangaugeName = data.userSelectedLanguageName;
    this.isLanguageEmpty = (this.selectedLangaugeName.length <= 0);
  }

  displayQRCode(data) {
    this.QrCodeStatus = this.checkStatus(data);
  }

  switchCreatorDemo(data) {
    this.creatorDemoStatus = data.currentTarget.checked ? this.globalconst.INCLUDE : this.globalconst.EXCLUDE;
  }
  switchNeroDemo(data) {
    this.neroDemoStatus = data.currentTarget.checked ? this.globalconst.INCLUDE : this.globalconst.EXCLUDE;
  }

  gameDemoChanges(val, event) {
    if (event.target?.checked) {
      this.available_game = val;
    } else {
      event.target.checked = true;
    }
  }
  //8314 end

  includeRxtSalesTool(data) {
    this.rxtStatus = this.checkStatus(data);
  }

  isPromotionRotation(data) {
    this.isAttractorLoopRadionBtn = false;
    this.isLogoContentEnabled = false;
    this.isSegmentContentEnabled = false;
    this.isincreasePromotionRotation = data.currentTarget.checked;
  }

  isInclude4K(data) {
    this.is4kVideoIncluded = data.currentTarget.checked;
  }

  isLogoContent(data) {
    this.isLogoContentEnabled = data.currentTarget.checked;
  }

  isSegmentContent(data) {
    this.isSegmentContentEnabled = data.currentTarget.checked;
  }

  isStandard(data) {
    if (this.contentTypeGaming.nativeElement.checked || this.contentTypeStandard.nativeElement.checked || this.contentTypeCreator.nativeElement.checked) {
      this.noContent = false;
    }
    else {
      this.noContent = true;
    }
    this.isStandardPart = data.currentTarget.checked;
    this.includeUnisonDemoStatus = this.isStandardPart ? this.includeUnisonDemoStatus : false;
    this.contentTypeGeneration(this.isStandardPart, GlobalConstants.STANDARD);
  }

  checkStatus(param) {
    if (param.currentTarget.checked) {
      return ($localize`:@@profile-info.mob-contantactless-exp.enabled:${GlobalConstants.ENABLED}`);
    } else {
      return ($localize`:@@profile-info.mob-contantactless-exp.disabled:${GlobalConstants.DISABLED}`);
    }
  }

  openAttractLoopModal() {
    this.openModal(this.attractLoopModal);
  }

  isUseMSProfileStatus(data) {
    this.useMSProfileStatus = data.currentTarget.checked;
  }

  isIposLiteChecked(data) {
    this.enableIposlitePRC = data.currentTarget.checked;
    this.iposLiteEnabled.emit(data.currentTarget.checked);
  }

  isUnisonDemoIncluded(data) {
    this.includeUnisonDemoStatus = data.currentTarget.checked;
  }

  getSelectedAttractLoopData(data) {
    if (data?.status) {
      this.attractLoop = {
        attractLoopId: data?.id,
        showOnDevice: true
      };
      this.isAttrctLoopSelected = true;
    } else {
      this.setDefaultAttractLoop();
      this.isAttrctLoopSelected = false;
    }
    this.isAttrLoopEmpty = false;
  }
  getAttractLoopCount(attrloopCount) {
    if (attrloopCount === 0) {
      this.isAttrLoopEmpty = true;
      this.setDefaultAttractLoop();
    } else {
      this.isAttrLoopEmpty = false;
    }

    if (this.selectedAttractLoopId && !this.isAttrLoopEmpty) {
      this.isAttrctLoopSelected = false;
    } else if (!this.selectedAttractLoopId && !this.isAttrLoopEmpty) {
      this.isAttrctLoopSelected = true;
    } else {
      this.isAttrctLoopSelected = false;
    }
  }
  checkingProfileInput() {
    let data = this.profileInfoFrm.get('profileName').value;
    this.specialChar = false;
    if (GlobalConstants.PROFILE_NAME_FORMAT.test(data)) {
      data = data.replace(GlobalConstants.PROFILE_NAME_FORMAT, '')
        .trim('');
      this.specialChar = true;
      this.profileInfoFrm.controls['profileName'].setValue(data);
    }
  }

  getShowDeviceNone(data) {
    if (data) {
      this.attractLoop = {
        showOnDevice: false
      };
    }
  }

  previewVideo() {
    this.playVid = true;
  }

  closePopup() {
    this.playVid = false;
  }

  setDefaultAttractLoop() {
    this.attractLoop = {
      showOnDevice: false
    };
  }
  classDecider(selectedVal) {
    if (this.profileInfoFrm?.controls?.excludeGameDemo?.value) {
      return this.available_game === selectedVal ? '' : 'unselected';
    }
    else {
      return 'disableClass';
    }
  }

  closeDemoModal() {
    this.modalReference.close();
  }
  enableGameDemo(content) {
    this.modalReference = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false
    });
  }

  //To fecth all Profile SKU's
  getAllProfileSkus() {
    return new Promise((resolve, reject) => {
      this.skuIdService.getAllSkuInfoByUSer('', this.retailerId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(getAllprofileSkuList => {
          this.profileSkuList = getAllprofileSkuList.skuContent;
          this.fetchedProfileSkus = this.profileSkuList.map(e => e.skuID);
          resolve(this.profileSkuList);
        });
    });
  }

  // Function to return matched content on search.
  SKUSearchFn(term: string, item: any) {
    return item?.internalName?.toLocaleLowerCase()?.includes(term?.toLocaleLowerCase()) || item?.publishedName?.toLocaleLowerCase()?.includes(term?.toLocaleLowerCase());
  }

  //To set select All Sku
  setSelectAllSkus(event) {
    this.disabledSelectedSkus = event.target.checked ? true : false;
    if (event.target.checked) { //if select all SKUs checked to true set selectedProfileSkus to blank.
      this.selectedProfileSkus = [];
    }
  }

  aiDemoClick(val, event) {
    if (event.target?.checked) {
      this.available_demo = val;
    } else {
      event.target.checked = true;
    }
  }

  aiClassDecider(selectedVal) {
    if (this.profileInfoFrm?.controls?.excludeAIDemo?.value) {
      return this.available_demo === selectedVal ? '' : 'unselected';
    }
    else {
      return 'disableClass';
    }
  }
}
